import React from 'react';
import * as FaIcons from 'react-icons/fa';

/** FA6 names that don't exist in react-icons/fa → map to FA5 equivalent */
const ICON_ALIASES = {
  FaGear: 'FaCog',
  FaHouse: 'FaHome',
  FaXmark: 'FaTimes',
  FaBarsStaggered: 'FaBars',
};

/** Resolve icon from react-icons/fa (with common FA6 aliases). */
export function resolveMenuIcon(iconStr) {
  if (!iconStr || typeof iconStr !== 'string') return null;
  const name = iconStr.trim();
  if (!name) return null;
  const mapped = ICON_ALIASES[name] || name;
  return FaIcons[mapped] || FaIcons[name] || null;
}

export function renderMenuIcon(iconStr) {
  const Icon = resolveMenuIcon(iconStr);
  return Icon ? <Icon /> : null;
}
